import React, { useRef, useState, useCallback, useEffect } from 'react';
import {
  MAP_LABEL_DEBOUNCE_DELAY,
  MAP_LABEL_MOUSE_POINTER_X_OFFSET,
  MAP_LABEL_MOUSE_POINTER_Y_OFFSET,
} from '../../../../../../constants/dealerLocator.constants';
import { debounceHandler } from '../../../../../../utils/debounceHandler.utils';

const AreaPolygonLabel = ({ label, containerRef }) => {
  const [pos, setPos] = useState<{ x: number; y: number } | null>(null);

  const timmerRef = useRef<ReturnType<typeof setTimeout>>();

  const getOffset = (e: MouseEvent, axis: 'x' | 'y') => {
    const targetElm = e.target as HTMLElement | null;
    if(axis === 'x'){
      if(e.offsetX){
        return e.offsetX;
      }
      const left = targetElm?.getBoundingClientRect()?.left ?? 0;

      return e.clientX - left;
    }

    if(e.offsetY){
        return e.offsetY;
      }
      const top = targetElm?.getBoundingClientRect()?.top ?? 0;
      
      return e.clientY - top;
  }

  const handleMouseMove = useCallback((e: MouseEvent) => {
    debounceHandler(() => setPos({ x: getOffset(e, 'x'), y: getOffset(e, 'y') }), timmerRef, MAP_LABEL_DEBOUNCE_DELAY);
  }, []);

  useEffect(() => {
    if (!containerRef?.current) {
      return;
    }

    containerRef?.current?.addEventListener('mousemove', handleMouseMove);

    return () => {
      containerRef?.current?.removeEventListener('mousemove', handleMouseMove);
    };
  }, [handleMouseMove, containerRef]);

  return (
    <>
      {pos && label && (
        <span
          style={{ left: `${pos?.x - MAP_LABEL_MOUSE_POINTER_X_OFFSET}px`, top: `${pos?.y - MAP_LABEL_MOUSE_POINTER_Y_OFFSET}px` }}
          className="dealer-locator-landing__map-tooltip"
        >
          {label}
        </span>
      )}
    </>
  );
};

export default AreaPolygonLabel;
